// extracted by mini-css-extract-plugin
export default {"wrapper":"LoaderWrapper_wrapper__QiHGr","wrapperLoading":"LoaderWrapper_wrapperLoading__lM7sO","loader":"LoaderWrapper_loader__Wnz05","rotation":"LoaderWrapper_rotation__F-f5L"};